module.exports = __webpack_public_path__ + "img/logo7year.ef650c76.png";